const angular = require('angular');
const app = angular.module('learn-services');
app.factory('NPS', ['Access', 'Storage', function(Access) {
    var self = this;
    self.nps = {
      hasBeenAdded: false,
      beingAdded: false,
      attempts: 0,
      add: function() {
        let token = Access.getAuthtoken();
        
        if (token.company && !token.company.feature_flags.enable_nps_surveys) {
          return;
        }
        self.nps.beingAdded = true;
        if (self.nps.hasBeenAdded === true) {
          return;
        }
        
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('class', 'js-nps');


        var user = token.user;

        var delightedOptions = {
          'email': user.email,
          'name': user.full_name,
          'properties': {
            'company': user.company
          },
          'initialDelay': 1209600
        };

        var waitForUser = setInterval(function() {
          self.nps.attempts++;
          if (self.nps.attempts === 10)
            clearInterval(waitForUser);
          if (self.nps.hasBeenAdded)
            clearInterval(waitForUser);

          if (!self.nps.hasBeenAdded && delightedOptions.email && delightedOptions.email.length > 0) {
            script.innerHTML = '!function(e,t,r,n){if(!e[n]){for(var a=e[n]=[],i=["survey","reset","config","init","set","get","event","identify","track","page","screen","group","alias"],s=0;s<i.length;s++){var c=i[s];a[c]=a[c]||function(e){return function(){var t=Array.prototype.slice.call(arguments);a.push([e,t])}}(c)}a.SNIPPET_VERSION="1.0.1";var o=t.createElement("script");o.type="text/javascript", o.async=!0, o.src="https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/"+r+"/"+n+".js";var p=t.getElementsByTagName("script")[0];p.parentNode.insertBefore(o,p)}}(window,document,"XWzBDZmSCPCgSPod","delighted");delighted.survey(' + JSON.stringify(delightedOptions) + ')';
            document.body.appendChild(script);
            self.nps.hasBeenAdded = true;
            self.nps.beingAdded = false;
            clearInterval(waitForUser);
          }
        }, 500);
      },
      remove: function() {
        if (document.querySelector('.js-nps')) {
          document.querySelector('.js-nps').remove();
        }
      }
    };
    return self.nps;
  }]);